import { render } from "./GTComponentSelect.vue?vue&type=template&id=642957cf&scoped=true"
import script from "./GTComponentSelect.vue?vue&type=script&lang=js"
export * from "./GTComponentSelect.vue?vue&type=script&lang=js"

import "./GTComponentSelect.vue?vue&type=style&index=0&id=642957cf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-642957cf"

export default script